var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "form-info" }, [
      _c("div", { staticClass: "form-row" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _c("div", { staticClass: "value" }, [
            _c("span", [_vm._v(_vm._s(_vm.voucher.no))])
          ])
        ])
      ]),
      _vm._v(" "),
      _vm.tradeVoucherType == 2
        ? _c("div", [
            _c("div", { staticClass: "form-row" }, [
              _vm._m(1),
              _vm._v(" "),
              _c("div", { staticClass: "form-value" }, [
                _c("div", { staticClass: "value" }, [
                  _c("span", [_vm._v(_vm._s(_vm.voucher.contractNo))])
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-row" }, [
              _vm._m(2),
              _vm._v(" "),
              _c("div", { staticClass: "form-value" }, [
                _c("div", { staticClass: "value" }, [
                  _c("span", [_vm._v(_vm._s(_vm.voucher.fstPartyHtBh))])
                ])
              ])
            ])
          ])
        : _c("div", { staticClass: "form-row" }, [
            _vm._m(3),
            _vm._v(" "),
            _c("div", { staticClass: "form-value" }, [
              _c("div", { staticClass: "value" }, [
                _c("span", [_vm._v(_vm._s(_vm.voucher.orderNo))])
              ])
            ])
          ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-row" }, [
        _vm._m(4),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _c("div", { staticClass: "value" }, [
            _c("span", [_vm._v(_vm._s(_vm.voucher.sellerName))])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-row" }, [
        _vm._m(5),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _vm.voucher.manualFlag
            ? _c("div", { staticClass: "value" }, [_vm._v("是")])
            : _c("div", { staticClass: "value" }, [_vm._v("否")])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-row" }, [
        _vm._m(6),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _c("div", { staticClass: "value" }, [
            _vm._v(_vm._s(_vm.voucher.creatorName))
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-row" }, [
        _vm._m(7),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _c("div", { staticClass: "value" }, [
            _vm._v(_vm._s(_vm.voucher.createTime))
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("交易单号")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("系统合同编号")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("合同编号")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("订单号")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("客户名称")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("是否手工创建")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("创建人")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("创建日期")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-cdbf390a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cdbf390a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/tradeVoucher/TradeVoucherDetail.vue
// module id = 2690
// module chunks = 0